import type { SVGProps } from 'react'

export const GermanFlag = ({ className, ...svgProps }: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 16" className={className} {...svgProps}>
      <rect width="24" height="16" fill="#000000" />
      <rect width="24" height="10.67" y="5.33" fill="#DD0000" />
      <rect width="24" height="5.33" y="10.67" fill="#FFCE00" />
    </svg>
  )
}
